import { createSelector } from "reselect";
import _ from "lodash";

const selectedFiltersSelector = state => state.selectedFilters;
const logSourcesSelector = state => state.logSources;
const errorsSelector = state => state.logSourceErrors;

export const getFilters = createSelector(
  selectedFiltersSelector,
  logSourcesSelector,
  (selectedFilters, logSources) => {
    const logSourceGroups = _.groupBy(
      logSources,
      logSource => logSource.groupName
    );
    const filters = Object.keys(logSourceGroups).map(key => {
      const isSelected = selectedFilters.filter(sf => sf === key).length > 0;
      return { key, isSelected };
    });

    return _.sortBy(filters, filter => filter.key);
  }
);

export const getVisibleLogSourceGroups = createSelector(
  selectedFiltersSelector,
  logSourcesSelector,
  (selectedFilters, logSources) => {
    const hasNoSelectedFilters = selectedFilters.length === 0;
    return logSources.filter(
      logSource =>
        selectedFilters.some(sf => sf === logSource.groupName) ||
        hasNoSelectedFilters
    );
  }
);

export const getLogSourcesHasErrors = createSelector(errorsSelector, errors => {
  return errors.length > 0;
});



// WEBPACK FOOTER //
// ./src/log-sources/selectors.js